import React from "react";
import "./recentproject.scss";
import {
  IconCalendarLight,
  IconDataDown,
  IconFilter,
} from "../../../icon/icons";
import Table from "react-bootstrap/Table";
import { images, ucfirst } from "../../../utils/customFn";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { useNavigate } from "react-router-dom";

const RecentProject = ({ latestOrders }) => {

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "pending";
      case "Accepted":
        return "success"; 
      case "Collecting":
        return "upcoming";
      case "Delivering":
        return "delivery-pending";
      case "Completed":
        return "completed";
      case "Cancelled":
        return "rejected";
      default:
        return "pending"; 
    }
  };

  const navigate = useNavigate();
  return (
    <div className="recent-project-data-box">
      <div className="page-card-bg">
        <div className="flex-top-heading">
          <div className="heading-main">
            <h2 className="common-heading"> Recent Orders</h2>
          </div>
          <div className="btn-filter-flex">
            <div className="btn-see-more">
              <button className="common-button-light" onClick={() => navigate("/orders")} >See All</button>
            </div>
          </div>
        </div>

        <div className="table-data-main look-data-table-new">
          <Table responsive>
            <thead>
              <tr>
                <th>Order Id</th>
                <th>Service</th>
                <th>Quantity</th>
              
                <th>Status </th>
              </tr>
            </thead>
            <tbody>
              {latestOrders &&
                latestOrders.map((item) => (

                  <tr key={item.id}>
                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>#{item?.id}</p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>{item?.getService?.service_descriptions?.title}</p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>{item?.quantity || "N/A"}</p>
                        </div>
                      </div>
                    </td>

                 

                    <td>
                      <div className="user-info">
                      <span className={getStatusClass(item.status)}>
                        {ucfirst(item.status)}
                      </span>
                      </div>
                    </td>

                  </tr>

                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default RecentProject;
